<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="glossy">
      <q-toolbar>
        

        <q-toolbar-title>
          Swoop
        </q-toolbar-title>

        
      </q-toolbar>
    </q-header>

    

    <q-page-container>
      <FormStep1 />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from 'vue'
import FormStep1 from './components/FormStep1.vue'
// import {ref,defineExpose,onMounted} from 'vue';
// import { Field, Form } from "vee-validate";
// import { cloneDeep, result } from 'lodash';

export default {
  name: 'LayoutDefault',

  components: {
    FormStep1
  },

  setup () {
    return {
      leftDrawerOpen: ref(false)
    }
  }
}
</script>
